import { EXPLORER } from './config'

export interface PoolInfoLink {
  href: string
  /** opens another site */
  external: boolean
  label: string
}

/**
 * Where a pool's own info page lives. CADINUdex and PancakeSwap pools open the Info hub of this app (it has both exchanges), Uniswap pools open
 * Uniswap's explorer page, any other exchange falls back to BscScan. The link follows the pool's exchange only; no exchange is preferred.
 */
export function poolInfoLink(dexName: string | undefined, pool: string): PoolInfoLink {
  const p = pool.toLowerCase()
  const v = dexName?.endsWith('V3') ? 'v3' : dexName?.endsWith('V2') ? 'v2' : null
  if (dexName?.startsWith('CADINUdex') && v) return { href: `/info/cadinu/pools/${p}?v=${v}`, external: false, label: 'Pool info on CADINUdex' }
  if (dexName?.startsWith('PancakeSwap') && v) return { href: `/info/pancakeswap/pools/${p}?v=${v}`, external: false, label: 'Pool info on PancakeSwap' }
  if (dexName?.startsWith('Uniswap')) return { href: `https://app.uniswap.org/explore/pools/bnb/${p}`, external: true, label: 'Pool on Uniswap' }
  return { href: `${EXPLORER}/address/${p}`, external: true, label: 'Pool on BscScan' }
}

export const shortId = (v: string) => (v && v.length > 12 ? `${v.slice(0, 6)}…${v.slice(-4)}` : v)
